module.exports = __webpack_public_path__ + "av.no1.387a5618.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/av.no1.jpg
// module id = WMUD
// module chunks = 0